import { toSmartScheduleKst } from '../smartSchedule/date';
import type { SmartScheduleEvent } from '../smartSchedule/types';
import { createQuickMoveDraft, QUICK_MOVE_DAY_MINUTES } from './time';
import type { QuickMoveDraft, QuickMoveSource } from './types';

/** 새 위치 앞뒤 3시간에서 시작하고, 그날 일정과 원래 위치가 모두 들어오도록 넓힌다. */
export const layoutQuickMovePreview = (source: QuickMoveSource, draft: QuickMoveDraft, events: SmartScheduleEvent[]) => {
    const day = toSmartScheduleKst(draft.date).startOf('day');
    const clip = (minutes: number) => Math.max(0, Math.min(QUICK_MOVE_DAY_MINUTES, minutes));
    const originalDraft = createQuickMoveDraft(source);
    const original = originalDraft.date === draft.date
        ? { start: clip(originalDraft.startMinutes), end: clip(originalDraft.endMinutes) }
        : null;
    const target = { start: clip(draft.startMinutes), end: clip(draft.endMinutes) };
    const intervals = events.map((event) => ({
        event,
        start: clip(toSmartScheduleKst(event.startTime).diff(day, 'minute', true)),
        end: clip(toSmartScheduleKst(event.endTime).diff(day, 'minute', true)),
    })).filter((item) => item.end > item.start).sort((left, right) => left.start - right.start);
    const start = Math.max(0, Math.floor(Math.min(target.start - 180, original?.start ?? target.start, ...intervals.map((item) => item.start)) / 60) * 60);
    const end = Math.min(QUICK_MOVE_DAY_MINUTES, Math.ceil(Math.max(target.end + 180, original?.end ?? target.end, ...intervals.map((item) => item.end)) / 60) * 60);
    const laneEnds: number[] = [];
    const blocks = intervals.map((item) => {
        let lane = laneEnds.findIndex((laneEnd) => laneEnd <= item.start);
        if (lane === -1) lane = laneEnds.length;
        laneEnds[lane] = item.end;
        return { ...item, lane };
    });
    const ticks = [start];
    for (let minute = start + 60; minute < end; minute += 60) ticks.push(minute);
    ticks.push(end);
    return { start, end, blocks, laneCount: laneEnds.length, original, target, ticks };
};
